module.exports = "<div mat-dialog-content>\r\n    <h4>\r\n        Announcement Message<br />\r\n    </h4>\r\n    <h4> SUBMITTING ….</h4>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/submit-dialog/submit-dialog.component.html
// module id = ./src/app/shared/submit-dialog/submit-dialog.component.html
// module chunks = main